import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

export interface ChangeExamItemDialogData {
  addedItems: string[];
  removedItems: Array<{
    examName: string;
    includedExamName: string;  // 已包含在哪個檢項中
  }>;
  buttonText: string;
  showCloseButton?: boolean;
  action: () => void;
}

/**
 * 單一按鈕通用dialog組件，對應樣式A
 */
@Component({
  selector: 'app-change-examItem-dialog',
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: './change-examItem-dialog.component.html',
  styleUrl: './change-examItem-dialog.component.scss',
})
export class ChangeExamItemDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ChangeExamItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeExamItemDialogData
  ) {}

  close() {
    if (this.data.action) {
      this.data.action();
    } else {
      this.dialogRef.close();
    }
  }
}
